<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        <li class="dl-nodemenu__item" data-uitleg="derivative_value" (click)="uitvoerToggleDValue()" title="{{ 'TOGGLE_Q_VALUE' | translate }}">
            <a class="value_menuitem"></a>
        </li>
        @if (effectiefModelleerniveau >= 40 && (!condtag || condtag.state === 'cons')) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('dp_correspondence_menu')" title="{{ 'CORR_SUBMENU' | translate }}">
                <a class="correspondence_general"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
    @if (actievSubmenu() === 'dp_correspondence_menu') {
        <ul class="dl-nodemenu__submenu">
            @if (!condtag || condtag.state === 'cons') {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dv_directed" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_dv_directed')" (click)="uitvoerInitAddAction({type: 'correspondence_dv_directed'})" title="{{ 'ADD_CORR_DIRECTED' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dv_normal" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_dv_normal')" (click)="uitvoerInitAddAction({type: 'correspondence_dv_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
            }
        </ul>
    }
</div>
